import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import SubmitButton from 'Components/UI/SubmitButton';
import SendIcon from '@material-ui/icons/Send';
import ErrorIcon from '@material-ui/icons/Error';
import FileUploadButton from './FileUploadButton';
import MessageTemplateOptionsMenu from './MessageTemplatesOptionsMenu';

const styles = theme => ({
  root: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'row',
  },
  attachmentUploadButton: {
    flex: 1,
  },
  attachmentUploadButtonProps: {
    width: '100%',
  },
  submitButton: {},
  additionalButton: {
    flex: 1,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  secondaryButtons: {
    marginBottom: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
  },
});

const MessageInputActions = ({
  className,
  classes,
  SubmitButtonProps,
  AdditionalButtonProps,
  AttachmentUploadButtonProps,
  TemplateOptionsMenuProps,
  showAttachmentsButton,
  showIconButtons,
  showAdditionalButton,
  showTemplateOptionsMenu,
  hideSend,
}) => {
  const {
    disabled: disabledProp,
  } = SubmitButtonProps;

  const [uploadProgress, setUploadProgress] = useState(null);
  const isUploading = uploadProgress !== null;

  // Icon Button Props (Submit)
  const IconButtonProps = showIconButtons ? {
    size: 'small',
    title: 'Send',
    icon: SendIcon,
    disabled: isUploading || disabledProp,
  } : undefined;

  return (
    <div
      id="message-input-actions"
      className={classNames(classes.root, className)}
    >
      {showTemplateOptionsMenu && (
        <MessageTemplateOptionsMenu
          {...TemplateOptionsMenuProps}
        />
      )}
      <div className={classes.buttonContainer}>
        <div className={classes.secondaryButtons}>
          {showAttachmentsButton && (
          <FileUploadButton
            className={classes.attachmentUploadButton}
            {...AttachmentUploadButtonProps}
            uploadProgress={uploadProgress}
            setUploadProgress={setUploadProgress}
            rounded={!showIconButtons}
            ButtonProps={{ className: classes.attachmentUploadButtonProps }}
          />
          )}

          {showAdditionalButton && (
          <SubmitButton
            className={classes.additionalButton}
            color="accentBlue"
            disableElevation
            variant="contained"
            successDuration={1000}
            text="Send"
            successText="Sent"
            savingText="Sending..."
            rounded={!showIconButtons}
            IconButtonProps={IconButtonProps}
            errorIcon={ErrorIcon}
            errorText="There was an issue."
            {...AdditionalButtonProps}
          />
          )}
        </div>
        {!hideSend && (
        <SubmitButton
          className={classes.submitButton}
          color="accentBlue"
          disableElevation
          variant="contained"
          successDuration={1000}
          text="Send"
          successText="Sent"
          savingText="Sending..."
          rounded={!showIconButtons}
          IconButtonProps={IconButtonProps}
          errorIcon={ErrorIcon}
          errorText="There was an issue."
          {...SubmitButtonProps}
        />
        )}
      </div>
    </div>
  );
};

MessageInputActions.defaultProps = {
  className: '',
  AttachmentUploadButtonProps: {},
  TemplateOptionsMenuProps: {},
  SubmitButtonProps: {},
  showAdditionalButton: false,
  AdditionalButtonProps: null,
  showAttachmentsButton: true,
  showIconButtons: false,
  showOptionsMenu: true,
  hideSend: false,
};

MessageInputActions.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  AttachmentUploadButtonProps: PropTypes.object,
  TemplateOptionsMenuProps: PropTypes.object,
  SubmitButtonProps: PropTypes.object,
  AdditionalButtonProps: PropTypes.object,
  showAttachmentsButton: PropTypes.bool,
  showAdditionalButton: PropTypes.bool,
  showIconButtons: PropTypes.bool,
  showOptionsMenu: PropTypes.bool,
  hideSend: PropTypes.bool,
};

export default withStyles(styles)(MessageInputActions);
